export default __webpack_public_path__ + "static/media/item_4@3x.48a5a357.webp";